module.exports = __webpack_public_path__ + "img/aig_new.659a8f1a.svg";